<template>
    <div class="" >
        <div class="uk-padding-large" >
            <div class="uk-container">
                <p class="uk-text-large ">
                    NCU allows you to be apart of something great, getting there is the first step on your journey.
                </p>
                <div class="">
                    <p class="uk-text-center uk-text-italic ">
                        Camoy Raye
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "undergradAlumniQuote"
    }
</script>

<style scoped>
    @media screen and (max-width:600px){



        p{
            font-size: 1em !important;
        }


    }
</style>
